import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Get } from "../../../../Request";
import { Color } from "../../../../Utils/styles";
export const useReserve = () => {
  const { pathname } = useLocation();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const renderCategory = cityName => {
    switch (pathname.split("/")[1]) {
      case "pool":
        return {
          id: 1,
          title: `رزرو استخر و پارك آبی ${cityName}`,
          img: window.origin + `/img/slider/4.webp`,
          sliderBox: "",
          sliderBox: () => {
            return (
              <h1>
                جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
                <span>{` `}</span>
                <span style={{ color: Color.blueSlider }}>
                  استخر و پارک های آبی
                </span>
              </h1>
            );
          },
          name: "استخر",
          status: false,
          form: { category_id: 1 },
          text: () => {
            if (data.contentbox) {
              return <div className="content-box">{data.contentbox}</div>;
            }
            return (
              <div className="content-box">
                <h2>رزرو استخر</h2>
                <p>
                  یکی از تفریحات خیلی محبوب در بین مردم شنا می باشد. شناکردن
                  فواید خیلی زیادی دارد که باعث می شود علاوه بر مفرح بودن، ورزش
                  مفیدی هم محسوب شود. یکی از دغدغه هایی که در بین ورزشکاران عزیز
                  وجود دارد، نبود یک سامانه جامع برای معرفی، اطلاع رسانی و رزرو
                  آنلاین استخرها و پارک های آبی راسر کشور است.
                </p>
                <p>
                  نیکوتن به عنوان جامع ترین سامانه معرفی، اطلاع رسانی و رزرو
                  آنلاین استخرها و پارک های آبی کشور محسوب می شود که اطلاعات
                  تمامی استخرها و پارک های آبی به همراه فیلم و عکس اختصاصی در
                  سایت و اپلیکیشن نیکوتن موجود می باشد.
                </p>
                <h3>رزرو آنلاین استخرها و پارک های آبی</h3>
                <p>
                  شما از طریق نیکوتن به راحتی می توانید استخر موردنظر خودتان را
                  پیدا کنید، شیفت های آن مجموعه را مشاهده کنید و به صورت کاملا
                  آنلاین و همراه با تخفیف استخر مورد نظر را رزرو نمایید. پس از
                  رزرو به شما بلیت داده خواهد شد و می توانید در هنگام ورود به
                  استخر، از این بلیت استفاده نمایید. همچنین به صورت پیامک هم
                  اطلاعات رزرو ارسال خواهد شد و در قسمت لیست سفارشات می توانید
                  بلیت موردنظر خود را ببینید.
                </p>
                <h3>استخرهای بانوان</h3>
                <p>
                  یکی از مواردی که همواره دغدغه بانوان عزیز می باشد، داشتن سانس
                  های مختلف استخر برای بانوان است. شما از طریق نیکوتن می توانید
                  استخرهایی که ویژه بانوان هستند، پیدا کنید و به راحتی آن ها را
                  رزرو نمایید. برخی از استخرهایی که در نیکوتن وجود دارند سانس
                  های بعد از ظهر و شب را هم به بانوان اختصاص داده اند.
                </p>
                <p>
                  پس اگر به دنبال استخرهای بانوان در شهرهای تهران، مشهد، نیشابور
                  و شاهرود هستید، حتما اپلیکیشن نیکوتن را نصب کنید یا از طریق
                  وبسایت رزرو خود را تکمیل نمایید.
                </p>
                <h3>پارک های آبی</h3>
                <p>
                  پارک های آبی به ویژه در شهرهای بزرگ همواره شلوغ هستند. ماندن
                  در صف های طولانی قطعا وقت زیادی را از شما خواهد گرفت. به همین
                  دلیل شما می توانید از طریق نیکوتن بلیت های مختلف پارک های آبی
                  را مشاهده کنید، فیلم های معرفی آن ها را ببینید و بلیت مجموعه
                  مورد نظر خود را بدون معطلی و در صف ماندن رزرو نمایید.
                </p>
                <h3>استخرهای تهران</h3>
                <p>
                  در شهرتهران با توجه به وجود تعداد زیاد استخر شما می توانید از
                  طریق نیکوتن استخرهای سرپوشیده و استخرهای روباز تهران را مشاهده
                  کنید و با توجه به امکانات و شیفتی که مدنظر دارید، استخر مورد
                  نظر خود را انتخاب نمایید. استخر هودین و هورام، استخر روباز
                  ولنجک، استخر شهید طوقانی، استخر شقایق و ... از جمله استخرهای
                  فعال در سایت و اپلیکیشن نیکوتن هستند.
                </p>
                <h3>استخرهای مشهد</h3>
                <p>
                  دومین کلان شهر ایران، یعنی شهر مشهد نیز دارای استخرهای فراوان
                  می باشد. استخرهای مشهد در مناطق مختلف و با امکانات متفاوت
                  هستند. پس اگر به دنبال رزرو استخرهای مشهد هستنید، بهترین گزینه
                  برای شما استفاده از سایت و اپلیکیشن نیکوتن می باشد. استخر 15
                  خرداد، استخر کوثر، استخر آستان قدس رضوی و .... از جمله
                  استخرهای فعال در سایت و اپلیکیشن نیکوتن هستند.
                </p>
                <p>
                  همچنین در مشهد پارک های آبی زیادی هم وجود دارد. سرزمین موج های
                  آبی، سرزمین موج های خروشان، پارک آبی ایرانیان و ... از جمله
                  این پارک ها محسوب می شوند. همین الان می توانید از طریق سایت و
                  اپلیکیشن نیکوتن تمامی اطلاعات و فیلم های پارک های آبی مشهد را
                  ببینید.
                </p>
                <h3>شهرهای فعال</h3>
                <p>
                  شهرهای فعال در بخش استخرها و مجموعه های آبی نیکوتن، تهران،
                  مشهد، نیشابور و شاهرود می باشند. همین الان می توانید استخرهای
                  تهران، استخرهای مشهد، استخرهای نیشابور و استخرهای شاهرود را از
                  طریق نیکوتن مشاهده و رزرو نمایید.
                </p>
              </div>
            );
          },
          desc: () => {
            return `معرفی، اطلاع رسانی و رزرو آنلاین استخر و پارک های آبی کشور
رزرو استخرهای مشهد، رزرو استخرهای تهران، رزرو استخرهای شاهرود، رزرو استخرهای نیشابور در نیکوتن فعال می باشد.
`;
          },
          city: false,
        };
      case "gym":
        return {
          id: 3,
          img: window.origin + `/img/slider/2.jpg`,
          title: `رزرو آنلاین باشگاه های ${cityName}`,

          sliderBox: () => {
            return (
              <h1>
                جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
                <span>{` `}</span>
                <span style={{ color: Color.primary }}>باشگاه های بدنسازی</span>
              </h1>
            );
          },
          name: "باشگاه",
          status: false,
          form: { category_id: 3 },
          text: () => {
            if (data.contentbox) {
              return <div className="content-box">{data.contentbox}</div>;
            }
            return (
              <div className="content-box">
                <h2>معرفی، اطلاع رسانی و رزرو آنلاین باشگاه های بدنسازی</h2>
                <p>
                  امروزه رشته بدنسازی یکی از محبوب ترین ورزش های کشور می باشد که
                  روزانه افراد زیادی به این ورزش مشغول هستند. شما از طریق نیکوتن
                  به عنوان جامع ترین سایت و اپلیکیشن معرفی، اطلاع رسانی و رزرو
                  آنلاین باشگاه های بدنسازی کشور می توانید باشگاه های بدنسازی
                  اطراف خودتان را پیدا کنید و به صورت کاملا آنلاین در آن ها ثبت
                  نام کنید.
                </p>
                <h3>رزرو آنلاین باشگاه های بدنسازی</h3>
                <p>
                  همواره یکی از دغدغه هایی که ورزشکاران رشته بدنسازی دارند، نبود
                  یک سیستم جامع برای معرفی، اطلاع رسانی و رزرو آنلاین مجموعه های
                  ورزشی می باشد. امروزه تعداد باشگاه های بدنسازی افزایش پیدا
                  کرده است و شما باید برای پیداکردن بهترین باشگاه بدنسازی ساعت
                  ها وقت خود را تلف کنید.
                </p>
                <p>
                  شما از طریق نیکوتن به عنوان جامع ترین سامانه معرفی، اطلاع
                  رسانی و رزرو آنلاین باشگاه های
                  {` باشگاه بدنسازی `}
                  می توانید باشگاه های بدنسازی اطراف خودتان را پیدا کنید،
                  اطلاعات باشگاه را بررسی کنید و در صورت رضایت به صورت کاملا
                  آنلاین و با تخفیف ویژه کاربران نیکوتن در آن ثبت نام کنید. شما
                  در صفحه هر باشگاه بدنسازی می توانید امکانات باشگاه را مشاهده
                  کنید، فیلم معرفی باشگاه را مشاهده کنید و به صورت آنلاین در آن
                  ها ثبت نام کنید.
                </p>
                <h3>باشگاه بدنسازی ویژه بانوان</h3>
                <p>
                  بانوان گرامی می توانند از طریق نیکوتن باشگاه های بدنسازی ویژه
                  بانوان را مشاهده کنند و سانس های آن ها را بررسی کنند. همواره
                  یکی از دغدغه های بانوان گرامی، شناسایی باشگاه های بدنسازی ویژه
                  بانوان می باشد که از طریق نیکوتن این کار به راحتی امکان پذیر
                  است.
                </p>
                <h3>شهرهای فعال</h3>
                <p>
                  هم اکنون در قسمت باشگاه های بدنسازی در نیکوتن شهرهای تهران،
                  مشهد، سمنان، شاهرود و نیشابور فعال هستند. با توجه به تعدد
                  باشگاه های بدنسازی در شهرهای مختلف از طریق لینک های پایین صفحه
                  می توانید شهر مورد نظر خود را پیدا کنید و به راحتی در باشگاه
                  مورد نظر خود ثبت نام کنید.
                </p>
                <h3>سیستم مدیریت باشگاه های بدنسازی</h3>
                <p>
                  یکی از ویژگی ها و مزیت هایی که سامانه نیکوتن برای مدیران
                  باشگاه های بدنسازی در نظر گرفته است، بحث مدیریت آنلاین باشگاه
                  های بدنسازی می باشد. تمامی مدیران باشگاه های بدنسازی می توانند
                  به صورت رایگان از پنل مدیریت نیکوتن استفاده کنند و در واقع
                  سیستم مدیریت آنلاین باشگاه خود را به صورت رایگان دریافت کنند.
                </p>
                <p>
                  شما می توانید با پشتیبانی نیکوتن به شماره 02191027127 داخلی یک
                  در تماس باشید و باشگاه بدنسازی خود را ثبت کنید. پس از فعالسازی
                  باشگاه شما در جدول تولید محتوا قرار خواهد گرفت تا فیلم
                  تبلیغاتی به صورت کاملا رایگان از باشگاه بدنسازی شما ساخته شود.
                </p>
                <h3>برخی از امکانات سیستم مدیریت باشگاه بدنسازی نیکوتن</h3>
                <ol>
                  <li>لیست کامل سفارشات</li>
                  <li>لیست ورزشکاران فعال و غیرفعال</li>
                  <li>لیست ورزشکاران هر شیفت</li>
                  <li>امکان ویرایش سانس ها</li>
                  <li>امکان پرداخت آنلاین و پرداخت در محل</li>
                  <li>امکان ویرایش قیمت شیفت ها</li>
                  <li>امکان حضور و غیاب ورزشکاران</li>
                  <li>امکان پاسخگویی به سوالات ورزشکاران</li>
                  <li>امکان مدیریت بر روی گوشی های هوشمند</li>
                  <li>امکان مدیریت چند مجموعه</li>
                  <li>امکان رزرو سریع برای کاربران</li>
                  <li>امکان برداشت درآمد</li>
                  <li>امکان ثبت قیمت با تخفیف</li>
                  <li>امکان ایجاد شیفت های مختلف</li>
                  <li>امکان ایجاد رول های متفاوت و ثبت چند مدیر مجموعه</li>
                  <li>ارسال پیامک یادآوری رزرو برای کاربران</li>
                  <li>تماس تلفنی جهت یادآوری رزرو کاربران</li>
                  <li>رشد تعداد ورزشکاران مجموعه</li>
                  <li>و ....</li>
                </ol>
              </div>
            );
          },
          desc: () => {
            return `باشگاه های بدنسازی اطراف خودتو به راحتی پیدا کن. معرفی، اطلاع رسانی رزرو آنلاین باشگاه های بدنسازی مشهد، تهران، نیشابور، شاهرود و سمنان از طریق نیکوتن. معرفی بهترین باشگاه های بدنسازی`;
          },
          city: false,
        };
      case "salon":
        return {
          id: 2,
          img: window.origin + `/img/slider/3.webp`,
          title: `رزرو آنلاین سالن های ورزشی ${cityName}`,

          sliderBox: () => {
            return (
              <h1>
                جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
                <span>{` `}</span>
                <span style={{ color: Color.yellow }}>سالن های ورزشی</span>
              </h1>
            );
          },
          name: "سالن",
          status: false,
          form: { category_id: 2 },
          text: () => {
            if (data.contentbox) {
              return <div className="content-box">{data.contentbox}</div>;
            }
            return (
              <div className="content-box">
                <h2>سالن های ورزشی</h2>
                <p>
                  رشته های توپی مثل فوتسال، والیبال، بسکتبال، هندبال و ...
                  معمولا طرفداران زیادی دارد. شما در نیکوتن می توانید لیست کاملی
                  از سالن های ورزشی کشور مشاهده کنید و در صورت فعال بودن رزرو آن
                  ها را به صورت آنلاین و با تخفیف رزرو کنید.
                </p>
                <h3>رزرو سالن های ورزشی</h3>
                <p>
                  شما در نیکوتن می توانید لیست کاملی از سالن های ورزشی مشهد،
                  سالن های ورزشی تهران، سالن های ورزشی سمنان، سالن های ورزشی
                  شاهرود و سالن های ورزشی نیشابور مشاهده کنید و آن ها را به صورت
                  کاملا آنلاین و باتخفیف ویژه رزرو کنید. سایت و اپلیکیشن نیکوتن
                  به عنوان پایگاه جامع معرفی و رزرو سالن های ورزشی شناخته می
                  شود. نیکوتن به عنوان اپلیکیشن رزرو سالن های ورزشی در کافه
                  بازار و مایکت موجود می باشد و می توانید سانس های موردنظر خود
                  را به صورت کاملا آنلاین رزرو کنید.
                </p>
                <h3>رزرو سالن فوتسال</h3>
                <p>
                  اولین رشته پرطرفدار که در بین سالن های ورزشی هم بیشتر برگزار
                  می شود ورزش فوتسال می باشد. فوتسال جزو رشته های پرطرفدار در
                  بین جوانان و نوجوانان می باشد.
                </p>
                <p>
                  معمولا در شهرهای مختلف سالن های فوتسال و یا سالن های ورزشی
                  چندمنظوره وجود دارد. رزرو سالن های فوتسال تهران، رزرو سالن های
                  فوتسال مشهد، رزرو سالن های فوتسال شاهرود و رزرو سالن های
                  فوتسال نیشابور در سایت و اپلیکیشن نیکوتن فعال می باشد. برای
                  ثبت سالن های ورزشی کافی است درخواست خود را از طریق شماره تماس
                  02191027127 داخلی یک در پشتیبانی نیکوتن ثبت کنید.
                </p>
                <p>
                  پس برای رزرو سالن های فوتسال کافی است اپلیکیشن نیکوتن را از
                  کافه بازار یا مایکت دانلود کنید و به صورت آنلاین سالن های
                  مدنظر خود را رزرو نمایید.
                </p>
                <h3>رزرو سالن والیبال</h3>
                <p>
                  دومین رشته که در بین رشته های توپی در ایران پرطرفدار است، رشته
                  والیبال می باشد. رزرو سالن های والیبال مشهد، نیشابور، شاهرود و
                  تهران در نیکوتن فعال شده است و شما می توانید به راحتی سالن
                  موردنظر خود را رزرو نمایید.
                </p>
                <h3>مدیریت سالن های ورزشی</h3>
                <p>
                  یکی از ویژگی ها و مزیت های رقابتی نیکوتن داشتن یک پنل آماده و
                  کامل برای رزرو سالن های فوتسال، رزرو سالن های والیبال، رزرو
                  سالن های بسکتبال و ... می باشد. به راحتی از طریق سیستم مدیریت
                  آنلاین سالن های ورزشی نیکوتن می توانید سالن خود را مدیریت کنید
                  و رزرو آنلاین آن را فعال کنید.
                </p>
                <p>
                  پنل مدیران سالن های ورزشی نیکوتن به گونه ای طراحی شده است که
                  به راحتی بتوانید به تمامی خدمات مختلف این پنل دسترسی داشته
                  باشید و به راحتی اطلاعات مورد نیاز خود را مشاهده کنید. برخی از
                  امکانات سیستم مدیریت آنلاین سالن های ورزشی به شرح زیر است:
                </p>
                <ol>
                  <li>ایجاد و ویرایش سانس های مختلف</li>
                  <li>نمایش به صورت جدول رزرو به کاربران</li>
                  <li>امکان رزرو آنلاین</li>
                  <li>امکان پرداخت در محل ویژه مدیران مجموعه ها</li>
                  <li>امکان ایجاد تخفیف برای برخی سانس ها</li>
                  <li>امکان رزرو قراردادی به صورت آنلاین</li>
                  <li>نمایش امکانات سالن های ورزشی به کاربران</li>
                  <li>تیزر تبلیغاتی سالن های ورزشی و قراردادن در صفحه تکی</li>
                  <li>امکان مشاهده لیست کامل سفارشات</li>
                  <li>امکان برداشت درآمد</li>
                  <li>امکان مشاهده لیست ورزشکاران</li>
                  <li>امکان مشاهده درآمد هفتگی و ماهیانه</li>
                  <li>اطلاع رسانی و تبلیغات پیامکی برای رزروها</li>
                  <li> و ...</li>
                </ol>
              </div>
            );
          },
          desc: () => {
            return `سامانه جامع رزرو آنلاین و اجاره اماکن و سالن های ورزشی کشور با تخفیف های ویژه و امتیازات متنوع به صورت کاملا آنلاین. رزرو سالن های ورزشی تهران، رزرو سالن های ورزشی مشهد و ...
`;
          },
          city: false,
        };
      // case "tehran":
      //   return {
      //     id: 329,
      //     img: window.origin + `/img/slider/3.jpg`,
      //     title: `رزرو آنلاین ${renderCategoryName()} تهران`,
      //     sliderBox: () => {
      //       return (
      //         <h1>
      //           جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
      //           <span>{` `}</span>
      //           <span style={{ color: Color.yellow }}>سالن های ورزشی</span>
      //         </h1>
      //       );
      //     },
      //     name: "سالن",
      //     status: false,
      //     form: { city_id: 329 },
      //     city: true,
      //   };
      // case "neyshabur":
      //   return {
      //     id: 502,
      //     img: window.origin + `/img/slider/3.jpg`,
      //     title: `رزرو آنلاین سالن های ورزشی ${cityName}`,
      //     sliderBox: () => {
      //       return (
      //         <h1>
      //           جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
      //           <span>{` `}</span>
      //           <span style={{ color: Color.yellow }}>سالن های ورزشی</span>
      //         </h1>
      //       );
      //     },
      //     name: "سالن",
      //     status: false,
      //     form: { city_id: 502 },
      //     city: true,
      //   };

      default:
        break;
    }
  };

  const getData = async () => {
    setLoading(true);
    await Get({
      url: "/data/reservepage",
      data: {
        ...renderCategory()["form"],
      },
    }).then(response => {
      setData(response);
      setLoading(false);
    });
  };
  const getDataByCity = (id, items) => {
    return items.filter(cityItems => cityItems.id == id)[0].items;
  };
  const changePath = category_id => {
    switch (+category_id) {
      case 3:
        return "/gym";
        break;
      case 2:
        return "/salon";
        break;
      case 1:
        return "/pool";
        break;
      default:
        break;
    }
  };
  return {
    data,
    loading,
    getData,
    renderCategory,
    getDataByCity,
    navigate,
    changePath,
    pathname,
  };
};
